// extracted by mini-css-extract-plugin
module.exports = {"item-rarity":"item-rarity-item-page_item-rarity__SYQCm","item-rarity-mobile":"item-rarity-item-page_item-rarity-mobile__qyv2I"};